'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// /~/react-dom/index.js
// module id = O27J
// module chunks = 0